import { Trans, useTranslation } from 'react-i18next';
import Link from '@amzn/awsui-components-react/polaris/link';
import { HelpPanel, Popover } from '@amzn/awsui-components-react';
import React from 'react';
import Button from '@amzn/awsui-components-react/polaris/button';

function CommunityOrgHelpTranslation() {
  const namespaces = ['events', 'translation'];
  const { t } = useTranslation(namespaces);

  return (
    <Trans
      i18nKey="eventDetailsStep.communityOrganizationInfo"
      t={t}
      tOptions={{ joinArrays: '' }}
      components={{
        h3: <h3> </h3>,
        b: <b />,
        br: <br />,
        ul: <ul />,
        li: <li />,
        link1: <Link external href="https://amazon.benevity.org/causes/search/" target="_blank" />,
        link2: <Link external href="https://amazon.benevity.org/nominate-cause" target="_blank" />,
      }}
    />
  );
}

export function CommunityOrganizationHelpPanel() {
  const namespaces = ['events', 'translation'];
  const { t } = useTranslation(namespaces);

  return (
    <HelpPanel
      data-testid="comm-org-help-panel"
      header={<h2>{t('eventDetailsStep.communityOrganization')}</h2>}
    >
      <CommunityOrgHelpTranslation />
    </HelpPanel>
  );
}

export function CommunityOrganizationHelpPopover() {
  const namespaces = ['events', 'translation'];
  const { t } = useTranslation(namespaces);

  return (
    <Popover
      data-testid="comm-org-help-popover"
      size="large"
      triggerType="custom"
      content={<CommunityOrgHelpTranslation />}
      header={t('eventDetailsStep.communityOrganization')}
      dismissAriaLabel={t('misc.close')}
    >
      <Button
        variant="inline-link"
        ariaLabel={t('eventDetailsStep.communityOrganizationInfoAriaLabel')}
      >
        {t('misc.info')}
      </Button>
    </Popover>
  );
}
